module.exports = __webpack_public_path__ + "static/media/logo-gobierno.009e10bf.png";